const aud = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" });

export const formatAud = (value: number | string) => aud.format(Number(value));
